<template>
  <div class="article-latest-news__wrapper">
    <section-title :to="$options.consts.linkToAllNews">
      Latest News
    </section-title>

    <article-bullet-list :articles="articles" :show-timestamp="true" />
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import SectionTitle from '../SectionTitle'
import ArticleBulletList from '../ArticleBulletList'
import { ROUTE_NAME } from 'enums/routes'

export default {
  name: 'SidebarLatestNews',
  components: { SectionTitle, ArticleBulletList },
  props: {
    articles: propValidator([PROP_TYPES.ARRAY])
  },
  consts: {
    linkToAllNews: {
      name: ROUTE_NAME.ALL_NEWS
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>
